exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pwd-hint[data-v-61895a6d] {\n  margin: 6px 0 0;\n  font-size: 12px;\n  line-height: 1.4;\n  color: #909399;\n}\n", ""]);

// exports
